import withSuspense from 'es/core/hocs/withSuspense';
import { useI18n } from 'es/core/hooks/useI18n';
import { useBlocker } from 'react-router-dom';

type NavigationPromptProps = {
    /**
     * Determines when the navigation prompt should be shown.
     */
    when: boolean;

    /**
     * Event handler invoked if the user elects to lose their changes
     */
    onLoseChanges?: () => void;
};

const NavigationPrompt = ({ when, onLoseChanges }: NavigationPromptProps) => {
    const { l10n } = useI18n('app/components');

    /**
     * Blocks navigation based on boolean value returned from the hook.
     * If true is returned, navigation will be blocked.
     */
    useBlocker(({ currentLocation, nextLocation }) => {
        // "when" condition isn't met, so do nothing
        if (!when) return false;

        // Current route isn't different from next route, so do nothing
        if (currentLocation.pathname === nextLocation.pathname) return false;

        // User has accepted their changes will be lost, so handle
        // losing any changes, and continue to the new route
        if (window.confirm(l10n('error.pageDirty'))) {
            onLoseChanges?.();
            return false;
        }

        // User has chosen to keep changes, so block navigation, remaining on the same screen
        return true;
    });

    return null;
};

export default withSuspense(NavigationPrompt);
